import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, SxProps, Theme } from '@mui/material';

interface IconComponentProps {
  icon: IconProp;
  color: string;
  size: number | string;
  sx?: SxProps<Theme>;
}

const IconComponent = function ({ icon, color, size, sx }: IconComponentProps): JSX.Element {
  return (
    <Box
      sx={{
        ...sx,
        '& svg': {
          fontSize: size,
        },
      }}
    >
      <FontAwesomeIcon icon={icon} color={color} />
    </Box>
  );
};

export default IconComponent;
